export default {
	language: 'nl',
	licenseKey: 'GPL',
	toolbar: {
		items: [
			'bold',
			'italic',
			'link',
			'bulletedList',
			'numberedList',
			'heading',
			'insertTable',
			'blockQuote',
		]
	},
	table: {
		contentToolbar: [
			'tableColumn',
			'tableRow',
			'mergeTableCells',
			'tableProperties',
			'tableCellProperties',
			'toggleTableCaption'
		]
	},
	link: {
		decorators: {
			openInNewTab: {
				mode: 'manual',
				label: 'Openen in een nieuw venster?',
				defaultValue: true,
				attributes: {
					target: '_blank'
				}
			}
		}
	}
};
